'use client'

import { useReportWebVitals } from 'next/web-vitals'

import { PostHogService, SentryService } from '@/services/tracking'

/**
 * Web-vitals reporting (replaces `src/reportWebVitals.ts` wired in the Vite
 * entry). Hooks into Next's metric stream and forwards each Core Web Vital to:
 *  - PostHog as a `web_vitals` event → build trends/insights per metric & route
 *  - Sentry as a breadcrumb → perf context attached to any error captured next
 *
 * Sentry's BrowserTracing already records pageload web vitals on its own; the
 * breadcrumb is intentionally lightweight (no extra issues created).
 */
export const WebVitals = () => {
  useReportWebVitals((metric) => {
    PostHogService.capture('web_vitals', {
      metric: metric.name,
      value: metric.value,
      rating: metric.rating,
      delta: metric.delta,
      navigation_type: metric.navigationType,
      pathname: window.location.pathname,
    })

    SentryService.addBreadcrumb({
      category: 'web-vitals',
      level: 'info',
      message: metric.name,
      data: {
        value: metric.value,
        rating: metric.rating,
        navigationType: metric.navigationType,
      },
    })
  })
  return null
}
